export default __webpack_public_path__ + "static/media/email.ca4ac6a6.svg";